import { SET_APP_SETTINGS } from './actionTypes';
import { IBFAppSettings } from '@appInterfaces/IBFAppSettings';
import { AnyAction } from 'redux';

const initialState = null;
function reducer(state: IBFAppSettings | null = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_APP_SETTINGS:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
}

export default reducer;
